module.exports = __webpack_public_path__ + "assets/img/talkshow.a84cd491.png";